import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { API_URL, UI_ROUTES } from 'src/app/app.contant';
import { RoleSelectionComponent } from 'src/app/modules/auth/modals/role-selection/role-selection.component';
import { IAPIResponse, IRoleResponse, RoleEnum } from 'src/app/modules/shared/models';
import { LocalStorageService } from 'src/app/modules/shared/services/local-storage/local-storage.service';
import { environment } from 'src/environments/environment';
import { DeviceUUID } from "device-uuid";
import { EncryptionService } from 'src/app/modules/dashboard/services/encryption.service';

(window as any).global = window;

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  // private loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this.isAuthenticated());
  public readonly ROUTES = UI_ROUTES;
  public refreshTokenTimeout: NodeJS.Timeout | undefined;

  constructor(
    private router: Router,
    private http: HttpClient,
    private modalService : BsModalService,
    private localStorageService: LocalStorageService,
    private _encryptionService: EncryptionService,
  ) { }

  public logOutUser() : void {
    this.clearAllStorage();
    // this.router.navigate(['/']);
  }

  public fetchUserRole(gid : string): Observable<IAPIResponse<Array<IRoleResponse>>> {
    return this.http.post<IAPIResponse<Array<IRoleResponse>>>(`${API_URL.ROLE}`, { gid });
  }

  public fetchUserRoleByGID(gid : string): Observable<IAPIResponse<Array<IRoleResponse>>> {
    const itracerUserRole = this.getCookiesUserRole();
    const body = environment.manualLogin ? { gid } : {gid, itracerUserRole };
    return this.http.post<IAPIResponse<Array<IRoleResponse>>>(`${API_URL.ROLE_GID}`, body );
  }

  public getToken(userId:any,role:any):Observable<IAPIResponse<any>>{
    return this.http.post<IAPIResponse<any>>(`${API_URL.GET_AUTH_TOKEN}`,{
      "user_name" : userId,
  
      "user_role" : role,
  
      "deviceId" : new DeviceUUID().get()
  
  } )
  }

  public getDeviceId(){
    const uuid = new DeviceUUID().get();
    const deviceId = new DeviceUUID().parse();
  }

  public getAccessList():any{
    return this.localStorageService.getAccessList()
  }

  // public fetchSupplierRole(vendor_id : string): Observable<IAPIResponse<Array<IRoleResponse>>> {
  //   return this.http.post<IAPIResponse<Array<IRoleResponse>>>(`${API_URL.VENDOR_LOGIN}`, { vendor_id });
  // }

  //// post login info starts

  public setUserRole(role : RoleEnum) : void {
    this.localStorageService.setUserRole(role);
  }

  public setAccessModule(module : string) : void {
    this.localStorageService.setAccessModule(module);
  }

  public setIpepAccessToken(IPEPToken: string){
    this.localStorageService.setIpepAccessToken(IPEPToken)
  }

  public getIpepAccessToken(): string | null{
    return this.localStorageService.getIpepAccessToken();
  }
  
  public setToken(token : string) : void {
    const jwtToken = JSON.parse(atob(token.split('.')[1]));
    const domain = jwtToken.domain;
    document.cookie = `Domain = ${domain}`;
    this.localStorageService.setAccessToken(token);
    this.localStorageService.setAccessModule(jwtToken.accessType);
    this.localStorageService.setAccessList(jwtToken.accessList);
  }

  public refreshToken(token:any){
    const jwtToken = JSON.parse(atob(token.split('.')[1]));
    const expires = new Date(jwtToken.exp * 1000);
    const timeout = (expires.getTime() - (Date.now())) - (30 * 10000);
    this.refreshTokenTimeout = setTimeout(() => this.getRefreshedToken().subscribe((res:any)=>{
      if(res){
        localStorage.removeItem("ACCESS_TOKEN")
        this.setToken(res.data?.access_token);
      }
    }), timeout);
  }

  public setUnregisteredVendorRole(){
    const token = this.getAccessToken()?.toString();
    const jwt = token?JSON.parse(atob(token.split('.')[1])):'';
    this.setUserRole(jwt.user_role)

  }

  public getRefreshedToken():Observable<IAPIResponse<any>>{
    return this.http.post<IAPIResponse<any>>(`${API_URL.REFRESH_TOKEN}`,{})
  }

  public getUserRole() : string | null {
    return this.localStorageService.getUserRole();
  }

  public setUserId(userId : string) : void {
    this.localStorageService.setUserId(userId);
  }

  public getUserId() : string | null {
    return this.localStorageService.getUserId();
  }

  public setUserDetails(userDetails : any) : void {
    this.localStorageService.setUserDetails(userDetails);
  }

  public getUserDetails() : any | null {
    return this.localStorageService.getUserDetails();
  }

   //// post login info ends

  public logout(): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.LOGOUT}`,{})
    
  }

  public clearAllStorage() {
    this.localStorageService.clear();
  }

  public isAuthenticated(): boolean {
    // const expiresAt = JSON.parse(this.localStorageService.getExpiresAt() || '{}');
    // return new Date().getTime() < expiresAt;
    const userID = this.getUserId();
    const userRole = this.getUserRole();
    return userID && userRole ? true : false;
  }

  public routeRedirection(roleInfo : RoleEnum | string ) {
    if(this.localStorageService.getAccessModule() === 'MODULE_ACCESS'){
      return this.loginToAccessModule();
    }else{
    if(roleInfo === RoleEnum.PO_BUYER) {
      this.router.navigate([this.ROUTES.PO_BUYER.HOME]);
    } else if(roleInfo === RoleEnum.SUPPLIER) {
      this.router.navigate([this.ROUTES.SUPPLIER.HOME]);
    } else if(roleInfo === RoleEnum.ADMIN) {
      this.router.navigate([this.ROUTES.ADMIN.HOME]);
    } else if(roleInfo === RoleEnum.EHS_MANAGER) {
      this.router.navigate([this.ROUTES.EHS_HOME])
    } else {
      this.router.navigate([this.ROUTES.HOME]);
    }
  }
  }

  public getAccessToken(): string | null{
    return this.localStorageService.getAccessToken();
  }

  public openLoginActionModal(roles : Array<RoleEnum>) : Observable<RoleEnum> {
    const initialState: ModalOptions<any> = {
      initialState: {
        title : "Choose Role",
        roles,
      },
      backdrop: 'static',
      class : 'modal-md'
    };
    const bsModalRef : BsModalRef = this.modalService.show(RoleSelectionComponent, initialState);
    return bsModalRef.content.onClose
  }

  /////// Cookies methods /////////

  private getCookie(name : string) : string {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return "";
  }

  public getCookiesUserId() {
    return this.getCookie("LoginId");
  }

  public getCookiesUserRole() {
    const userRole = this.getCookie("UserRole")
    return userRole ? userRole : "SiemensUser";
  }

  public getCookiesDomain() {
    const domain = this.getCookie("Domain");
    return domain ? domain : "AD001";
  }

  public checkPoApproverAcknowledgement(prId:any){
    return this.http.post(`${API_URL.CHECKPOAPPROVERACKNOWLEDGMENT}`,{"prId":prId})
  }

  public fetchPOHistory(){
    return this.http.post(`${API_URL.FETCH_POHISTORY}`,{})
  }
  public findUserDetails(guId: any): Observable<any> {
    return this.http.get<any>(API_URL.FIND_USER_BY_GUID + guId + "&Team=" + "PR2PO");
  }

  public getITracerAuthToken(): Observable<any> {
    return this.http.get<any>(`${API_URL.GET_ITRACER_AUTH}`);
  }

  public deleteGuId(guId: any, role: string): Observable<any> {
    return this.http.post<any>(API_URL.DELETE_GUID + '?Guid=' + guId + '&Status=Delete&Role=' + role + '&Team=PR2PO', null);
  }

  public updateStorageAndRedirect(roleInfo : IRoleResponse, userID: any,access_token:any) {
    roleInfo.gid = userID;
    console.log("roleInfo",roleInfo);
    
    // this.refreshToken(access_token)
    this.setUserRole(roleInfo.role as RoleEnum)
    this.setUserDetails(roleInfo);
    this.setUserId(userID);
    this.routeRedirection(roleInfo.role);
  }

  public checkTemplateId(templateId:any):Observable<any> {
    return this.http.get<any>(API_URL.FIND_TEMPLATE_ID + templateId);
  }

  public loginToAccessModule(){
    this.router.navigate([this.ROUTES.ACCESS_MODULE.ACCESS_MODULE]);
  }
}
